export default __webpack_public_path__ + "static/media/registerImage.c1769a78.svg";